import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { createQueryKeyString } from '@core/react-query/queryParams'
import { RequestTypes } from './requestTypes'

const checkInQueryKeys = createQueryKeys('checkIn', {
  openSessions: (payload: RequestTypes['getOpenCheckInSessions']) => ({
    queryKey: [
      payload.resourceType,
      payload.organisationId,
      payload.projectId,
      payload.page,
      payload.size,
      payload.term,
      payload.overdue,
      payload.sortBy,
      payload.locationIds,
      payload.processTagIds,
    ],
    queryFn: async () => {
      const { data } = await APIAxiosInstance.get(
        `check-ins${createQueryKeyString(payload)}`,
      )
      return data
    },
  }),
})

const checkInMutationKeys = createMutationKeys('checkIn', {})

export const checkInKeys = mergeQueryKeys(
  checkInQueryKeys,
  checkInMutationKeys,
).checkIn
